import { Accordion, AccordionDetails, AccordionSummary, Card, CardContent, Grid, TablePagination, Typography } from "@mui/material";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import Footer from "pages/LandingPages/Author/sections/Footer";
import MKBox from "components/MKBox";
import bgImage from "../../assets/images/city-profile.jpg"
import { useState } from "react";
import { useEffect } from "react";
import { get } from "utility/fetch";
import { numberWithCommas } from "utility/general";
import EbanqoHelmet from "layouts/EbanqoHelmet";


export default function Transactions() {

    const [transactions, setTransactions] = useState([])
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // Calculate the number of pages needed
  const numberOfPages = Math.ceil(transactions?.length / rowsPerPage);

  // Get the items for the current page
  const paginatedItems = transactions.slice((page - 1) * rowsPerPage, page * rowsPerPage);

    const handleChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const getAllTransactions = async () => {
        let res = await get(`/all-customer-transactions/${sessionStorage.getItem('pin')}`)
        console.log(res)
        if (res.statusCode === 200 || res?.status === 200) {
            setTransactions(res?.data?.data)
        }
        else {
            console.log(res)
        }
    }


    useEffect(() => {
        getAllTransactions();
    }, [])




    return (
        <div>
            <EbanqoHelmet />
            <DefaultNavbar
                routes={routes}
                action={{
                    type: "external",
                    route: "https://www.creative-tim.com/product/material-kit-react",
                    label: "free download",
                    color: "info",
                }}
                transparent
                light
            />
            <MKBox
                minHeight="10rem"
                width="100%"
                sx={{
                    backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
                        `${linearGradient(
                            rgba(gradients.dark.main, 0.8),
                            rgba(gradients.dark.state, 0.8)
                        )}, url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "grid",
                    placeItems: "center",
                }}
            />
            <Grid container sx={{ mb: 5, mt: 5 }} justifyContent={"center"} spacing={3}>
                <Grid item>
                    <Card>
                        <CardContent>
                            <Typography textAlign={"center"} variant="h5" gutterBottom>All</Typography>
                            <Typography textAlign={"center"} variant="body2">All Transactions</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item>
                    <Card>
                        <CardContent>
                            <Typography textAlign={"center"} variant="h5" gutterBottom>Contributions</Typography>
                            <Typography textAlign={"center"} variant="body2">Normal Contributions and Additional Voluntary Contribution</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item>
                    <Card>
                        <CardContent>
                            <Typography textAlign={"center"} variant="h5" gutterBottom>Withdrawals</Typography>
                            <Typography textAlign={"center"} variant="body2">Withdrawal Transactions</Typography>
                        </CardContent>
                    </Card>
                </Grid>

            </Grid>


            <Typography textAlign={"center"} variant="h4" >
                Transactions
            </Typography>
            <Typography textAlign={"center"} variant="h5">
                All your pension transactions
            </Typography>


            {Array.isArray(transactions) && transactions.length > 0 && paginatedItems.map((item) => (
                <Grid key={item?.id} container direction={"column"} sx={{ mt: 5, justifyItems: "center", alignContent: "center", justifyContent: "center" }}>
                    <Grid sx={{ width: "60%" }} item xs={12}>
                        <div>
                            <Accordion sx={{ width: "100%" }}>
                                <AccordionSummary
                                    // expandIcon={<ExpandMoreIcon />}
                                    sx={{ width: "100%" }}
                                    justifyContent="spaceBetween"
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid sx={{ width: "100%", alignItems: "center", alignContent: "spaceBetween", justifyContent: "center" }} container direction="row">
                                        <Grid item xs={1}>
                                            <ArrowCircleDownIcon fontSize="large" color="success" />
                                        </Grid>

                                        <Grid container alignContent={"center"} xs={5} direction={"column"} item>
                                            <Grid item xs={4}>
                                                {item?.narration}
                                            </Grid>

                                            <Grid item xs={4}>
                                                {new Date(item?.valueDate).toDateString()}
                                            </Grid>
                                        </Grid>

                                        <Grid textAlign={"end"} item xs={6}>
                                            {`N${numberWithCommas(item?.totalContribution)}`}
                                        </Grid>

                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails sx={
                                    {
                                        borderTop: "1px solid black",
                                    }
                                }>
                                    <Grid container direction={"column"} sx={{ borderTop: "1px", justifyItems: "center", alignContent: "center", justifyContent: "center" }}>
                                        <Grid item sx={{ textAlign: "center", borderTop: "1px", justifyItems: "center", alignContent: "center", justifyContent: "center" }}>
                                            <ArrowCircleDownIcon fontSize="large" color="success" />
                                        </Grid>
                                        <Grid item sx={{ textAlign: "center" }}>
                                            <h3>{item?.narration}</h3>
                                            <p>{new Date(item?.valueDate).toDateString()}</p>
                                        </Grid>
                                    </Grid>
                                    <Grid container direction={"column"} sx={{ mt: 5, alignItems: "center", alignContent: "center" }}>
                                        <Grid container sm={6} item flex sx={{ justifyContent: "space-between" }}>
                                            <Grid item>
                                                Employer Contribution
                                            </Grid>
                                            <Grid item>
                                                {numberWithCommas(item?.employerContribution)}
                                            </Grid>
                                        </Grid>
                                        <Grid container sm={6} item flex sx={{ justifyContent: "space-between" }} >
                                            <Grid item>
                                                Employee Contribution
                                            </Grid>
                                            <Grid item>
                                                {numberWithCommas(item.employeeContribution)}
                                            </Grid>
                                        </Grid>
                                        <Grid container sm={6} item flex sx={{ justifyContent: "space-between" }} >
                                            <Grid item>
                                                Voluntary Contribution
                                            </Grid>
                                            <Grid item>
                                                {numberWithCommas(item.avc)}
                                            </Grid>
                                        </Grid>
                                        <Grid container sm={6} item flex sx={{ justifyContent: "space-between" }} >
                                            <Grid item>
                                                Fees
                                            </Grid>
                                            <Grid item>
                                                {numberWithCommas(item?.fees)}
                                            </Grid>
                                        </Grid>
                                        <Grid container sm={6} item flex sx={{ justifyContent: "space-between" }} >
                                            <Grid item>
                                                Total Amount
                                            </Grid>
                                            <Grid item>
                                                {numberWithCommas(item?.totalContribution)}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </Grid>
                </Grid>
            ))
            }
            <Grid container sx={{width:"80%", justifyContent:"end"}}>
                <TablePagination
                    component="div"
                    count={numberOfPages}
                    page={page}
                    onPageChange={handleChange}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Grid>


            <Footer />
        </div>
    );
}